import { useEffect, useState } from 'react';
import { getExtensionId } from '../../util/get-extension-id';

type IReturnType = {
  isInstalled: boolean | undefined;
  versionInstalled: string | undefined;
};

export const useExtensionDetails = (): IReturnType => {
  const [isInstalled, setIsInstalled] = useState<boolean | undefined>(undefined);
  const [versionInstalled, setVersionInstalled] = useState<string | undefined>(undefined);

  useEffect(() => {
    const extensionId = getExtensionId();
    if (!extensionId || !window.chrome?.runtime?.sendMessage) {
      setIsInstalled(false);
      return;
    }

    try {
      chrome.runtime.sendMessage(
        extensionId,
        { type: 'GET_VERSION' },
        (response) => {
          if (chrome.runtime.lastError || !response) {
            setIsInstalled(false);
          } else {
            setIsInstalled(true);
            setVersionInstalled(response.version);
          }
        }
      );
    } catch {
      setIsInstalled(false);
    }

    // Fallback timeout in case sendMessage never calls back
    const timeoutId = setTimeout(() => {
      setIsInstalled((prev) => (prev === undefined ? false : prev));
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, []);

  return { isInstalled, versionInstalled };
};
